import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AppHypotheekMixin } from '../mixins/AppHypotheekMixin';
import AppWijzigenAdviseurVue from './adviseur/AppWijzigenAdviseur.vue';
import AppWijzigenZelfVue from './zelf/AppWijzigenZelf.vue';

@Component({
  components: {
    'app-wijzigen-zelf': AppWijzigenZelfVue,
    'app-wijzigen-adviseur': AppWijzigenAdviseurVue
  }
})
export default class AppWijzigen extends Mixins(AppHypotheekMixin) {
  @Prop()
  public uploadRekeningnummerSucceeded!: boolean;
  @Prop()
  public uploadTaxatieSucceeded!: boolean;

  mounted() {
    this.$nextTick(() => {
      const root = this.$el as HTMLElement | null;
      if (!root) return;
      const navLinks = root.querySelectorAll('.nav-link');
      navLinks.forEach(el => (el as HTMLElement).setAttribute('tabindex', '0'));
    });
  }
}
